import { hydrate, type Component } from "svelte";
import type { KestrelStores, ServerResult } from "@kestrel/stores";
import { rootComponent, type ResolvedComponent } from "@kestrel/internal/client";
import { entryIslandAttribute } from "../../utils/consts";
import type { RootProps } from "../component/root.types";
import { noop } from "../../utils/function";
import { createRootContext } from "../context/createRootContext";

export const islandRegistry = new Map<string, HTMLScriptElement | false>();

/**
 *
 *
 *
 *
 *
 *
 *
 */
/*           */
export const getComponentByIslandId = (
  islandId: string,
  [defaultComponent, islandsMap]: ResolvedComponent,
  /*                                                          */
): Component<any, any> | undefined => {
  /*                                                */
  return islandId === "default" ? defaultComponent : islandsMap[islandId];
};

/**
 *
 *
 *
 *
 *
 */
/*           */
export const getIslandIdFromScript = (islandScript: HTMLScriptElement): string => {
  const islandId = islandScript.getAttribute(entryIslandAttribute);

  if (!islandId && import.meta.env.DEV) {
    throw new Error("Island script element does not have islandId attribute");
  }

  return islandId!;
};

/**
 *
 *
 *
 */
let invokeHydrator: () => void = noop;

/**
 *
 *
 *
 *
 */
/*           */
export const registerIslandEntrypoint = (current: HTMLScriptElement): void => {
  const islandId = getIslandIdFromScript(current);
  islandRegistry.set(islandId, current);
  invokeHydrator();
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
/*           */
export const hydrateIsland = (
  stores: KestrelStores,
  ssrState: ServerResult,
  resolvedComponent: ResolvedComponent,
  islandScript: HTMLScriptElement,
  islandId: string,
): void => {
  const target = islandScript!.parentElement;

  if (!target && import.meta.env.DEV) {
    throw new Error("Island script element is not attached to a parent");
  }

  const component = getComponentByIslandId(islandId!, resolvedComponent);
  if (!component && !ssrState.error && import.meta.env.DEV) {
    throw new Error(`Island component with id ${islandId} not found`);
  }

  /*                           */
  /*                                 */
  hydrate(rootComponent, {
    target: target!,
    props: { component, island: islandId! } satisfies RootProps,
    context: createRootContext(stores),
  });
};

/**
 *
 *
 *
 *
 *
 */
/*           */
export const propagateIslandsFromEntrypoint = (entrypoint: HTMLScriptElement): void => {
  const islandsValue = getIslandIdFromScript(entrypoint);
  const islands = islandsValue.split(",").map((island) => island.trim());

  /*                                                                               */
  /*                                                                                    */
  islands.forEach((island) => {
    if (!islandRegistry.has(island)) islandRegistry.set(island, false);
  });
};

/**
 *
 *
 *
 *
 *
 *
 */
/*           */
export const hydrateIslandsIfAllRegistered = (
  stores: KestrelStores,
  ssrState: ServerResult,
  resolvedComponent: ResolvedComponent,
): void => {
  invokeHydrator = () => {
    /*                                                                              */
    (islandRegistry as Map<string, HTMLScriptElement>).forEach(
      hydrateIsland.bind(null, stores, ssrState, resolvedComponent),
    );
  };

  /*                                          */
  if ([...islandRegistry.values()].every((value) => !!value)) invokeHydrator();
};
